import { useEffect, useRef } from 'react';
import { useToast } from '@/hooks/use-toast';
import { Notification } from './useNotifications';

export function useNotificationToasts(notifications: Notification[]) {
  const { toast } = useToast();
  const previousNotificationsRef = useRef<Notification[]>([]);

  useEffect(() => {
    // Skip on initial load
    if (previousNotificationsRef.current.length === 0 && notifications.length > 0) {
      previousNotificationsRef.current = notifications;
      return;
    }

    // Check for new notifications
    const newNotifications = notifications.filter(
      (notification) =>
        !previousNotificationsRef.current.some((prev) => prev.id === notification.id)
    );

    // Show toast for each new notification
    newNotifications.forEach((notification) => {
      toast({
        title: notification.title,
        description: notification.message,
        duration: 5000,
      });
    });

    previousNotificationsRef.current = notifications;
  }, [notifications, toast]);
}
